module.exports = __webpack_public_path__ + "media/images/icons/country_flags/fm-18f7e08960b73974ccd456e9f2ff139a.svg";